import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=93683432"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=93683432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports